// extracted by mini-css-extract-plugin
module.exports = {"isInvalid":"CustomMessageModal_isInvalid__RwAtk","infoText":"CustomMessageModal_infoText__r8sHv","infoTextInvalid":"CustomMessageModal_infoTextInvalid__1uwNg"};